export var MessagingError = function (message) { return "Messaging Error: " + message; };
export var MessagingAPIError = function (message, response) { return ({
    message: "Messaging API Error: " + message,
    response: response,
}); };
export var convertArrayToListString = function (arr) {
    return arr.reduce(function (prev, curr, index) { return "" + prev + curr + (index === arr.length - 1 ? '' : ','); }, '');
};
//# sourceMappingURL=utils.js.map